import { default as axios } from './http';


class StockpilingAPI {

  getStockpiling = async () => {
    // Fetch tarps from API
    console.log('Fetching stockpiling works from API...')
    const url = '/api/v1/gcm/stockpiling/';
    const response = await axios.get(url)
    return response
  }

  createStockpiling = async (data) => {
    // Create tarping works in API
    const url = '/api/v1/gcm/stockpiling/';
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    }
    const response = await axios.post(url, data, options)
    return response
  }

}

export default StockpilingAPI;